import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createCajaCurricularSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
  arr_espacios_id: yup
    .array()
    .of(yup.number().required(DEFAULT_MESSAGES.REQUIRED))
    .min(1, DEFAULT_MESSAGES.REQUIRED),

  arr_planes_estudio_id: yup
    .array()
    .of(yup.number().required(DEFAULT_MESSAGES.REQUIRED))
    .min(1, DEFAULT_MESSAGES.REQUIRED),
});
